import { SxProps } from '@mui/material';

export const catalogEntryListCompareCollectorDiagnosticSX: SxProps = {
	color: 'grey.500',
	fontSize: '14px',
	fontWeight: '500',
};
